<template>
    <a :href="route"
        class="pr-6 -ml-12 flex-1 flex flex-col hover:text-blue-700 items-end justify-center text-blue-500 bg-white hover:bg-blue-100 focus:outline-none focus:shadow-none select-none"
    >
        <span v-if="closing_date" class="font-semibold text-gray-600 text-base">
            {{ closing_date }}
        </span>

        <div class="user-details uppercase tracking-wide font-semibold pt-2">
            {{ $t('View Details') }}
        </div>
    </a>
</template>

<script>
export default {
    props: {
        property_id: {},
        closing_date: {},
        route: {},
    },
}
</script>
